import React, { Component } from 'react'
import { connect } from 'react-redux';
import { FaCheck, FaTimes } from 'react-icons/fa';

import { editCharacter } from 'redux/actions';

import Paths from 'paths';

class CharacterEdit extends Component{

    componentDidMount() {
        this.id.focus(); 
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.editCharacter(
            this.props.soundbox, 
            this.props.character.id,
            { 
                id: +this.id.value,
                name: this.title.value
            }
        );
        this.props.history.push(Paths.PATH_ADMIN_SHOW_SOUNDBOX.replace(':soundboxId', this.props.soundbox.id));
    }

    cancel = (e) => {
        this.props.history.push(Paths.PATH_ADMIN_SHOW_SOUNDBOX.replace(':soundboxId', this.props.soundbox.id));
    }

    render() {
        return (
            <form onSubmit={(e) => this.handleSubmit(e)} className={'soundbox-grid-bar'}>
                <div className={'soundbox-grid-bar-id'}> 
                    <input type="number" name="form-id" required defaultValue={this.props.character.id} ref={input => this.id = input} />
                </div>
                <div className={'soundbox-grid-bar-title'}>
                    <input type="text" name="form-title" required defaultValue={this.props.character.name} ref={input => this.title = input} />
                </div>
                <button type="submit" className={'soundbox-grid-bar-save'}>
                    <FaCheck />
                </button>
                <div className={'soundbox-grid-bar-cancel'} onClick={this.cancel}>
                    <FaTimes />
                </div>
            </form>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        editCharacter: (soundbox, oldId, item) => {
            dispatch(editCharacter(soundbox, oldId, item))
        }
    }
}

export default connect(null, mapDispatchToProps)(CharacterEdit);